export const zeroDistance = { dist: 0, is_override: false };

/** Stands in for a route that could not be obtained. Keeps the matrix populated
 * so a caller needing every pair still runs, while staying tellable from a
 * measured zero. */
export const unresolvedDistance = {
  dist: 0,
  is_override: false,
  unresolved: true,
};
